import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import FlexTaskMonitor from './FlexStudio/FlexTaskMonitor';

/**
 * TaskMonitorPage - Standalone page for Task Monitor
 * Accessible from FAST Studio sidebar
 */
function TaskMonitorPage() {
  const navigate = useNavigate();

  const colors = {
    background: '#09090b',
    surface: '#18181b',
    surfaceElevated: '#27272a',
    border: '#27272a',
    textPrimary: '#ffffff',
    textSecondary: '#a1a1aa',
    textMuted: '#71717a',
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: colors.background,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 2,
          py: 1,
          borderBottom: `1px solid ${colors.border}`,
          bgcolor: colors.surface,
        }}
      >
        <Tooltip title="Back to FAST Studio">
          <IconButton
            onClick={() => navigate('/studio')}
            sx={{ color: colors.textSecondary, '&:hover': { color: colors.textPrimary } }}
          >
            <HomeIcon />
          </IconButton>
        </Tooltip>
        <Typography variant="h6" sx={{ color: colors.textPrimary, fontWeight: 600 }}>
          Task Monitor
        </Typography>
      </Box>

      {/* Task Monitor - expanded by default */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <FlexTaskMonitor isCollapsed={false} onToggleCollapse={() => {}} standalone={true} />
      </Box>
    </Box>
  );
}

export default TaskMonitorPage;
